import { OverlayModule } from '@angular/cdk/overlay';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCommonModule, MatRippleModule } from '@angular/material/core';
import { MatMenuTriggerDirective, MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER } from './menu-trigger.directive';
import { MatMenuContentDirective } from './menu-content.directive';
import { MatMenuItemComponent } from './menu-item';
import { MatMenuComponent } from './menu.component';

@NgModule({
  imports: [CommonModule, MatCommonModule, MatRippleModule, OverlayModule],
  exports: [
    CdkScrollableModule,
    MatCommonModule,
    MatMenuComponent,
    MatMenuItemComponent,
    MatMenuTriggerDirective,
    MatMenuContentDirective,
  ],
  declarations: [MatMenuComponent, MatMenuItemComponent, MatMenuTriggerDirective, MatMenuContentDirective],
  providers: [MAT_MENU_SCROLL_STRATEGY_FACTORY_PROVIDER],
})
export class MenuModule {}
